/**
 * MobileTab
 * @requires [lib/util.js]
 *
 * namespace
 * config
 * init
 */

/**
 * namespace
 * @type {Object}
 */
SDG.MobileTab = SDG.MobileTab || {};


/**
 * config
 * @type {Object}
 */
SDG.MobileTab.config = {

	// classes
	cls: {
		active: 'is-active',
		tabBtn: 'tab-btn'
	},

	// id
	id : {
		select: 'tabSelect'
	},

	url_hash: false
};

/**
 * init
 * @param  {Object} opts
 * @return {Object}
 */

SDG.MobileTab.init = function(opts) {
	var config = SDG.MobileTab.config,
		c = _.extend(config, opts);

	/**
	 * init
	*/
	function init() {
		// add events
		addEvent();

		if (c.url_hash) {
			urlHash();
		}
   	}

	/**
	 * select events
	 */
	function addEvent() {
		_.addEvent({
		   id: c.id.select,
		   event: 'change',
		   fn: showTab
	   });
	}

	/**
	 * open tab on select
	 * @return {[type]} [description]
	 */
   	function showTab() {
		document.getElementById(this.value).click();
	}

	/**
	 * detect url hash
	 * @return {[type]} [description]
	 */
	function urlHash() {
		var hash,
			sel,
			opts,
			opt,
			j;

		sel = document.getElementById(c.id.select);
		opts = sel.options;


		if (window.location.hash) {
			hash = window.location.hash.replace('#','tab');

			for (j = 0; j < opts.length; j++) {
				opt = opts[j];
				if (opt.value === hash) {
			      	sel.selectedIndex = j;
			      	break;
			    }
			}
		}
	}

	return init();
};

/**
 * press templates
 *
 * namespace
 * grid item
 * modal content
 * modal content video
 * product title
 */

/**
 * PressTemplate namespace
 * @type {Object}
 */
SDG.PressTemplate = SDG.PressTemplate || {};

/**
 * grid item
 * @param  {Object} data
 * @return {string}
 */
SDG.PressTemplate.gridItem = function(data) {

	/**
	 * init
	 */
	function init() {
		return getHtml().trim();
	}

	/**
	 * get html
	 * @param  {Object} data
	 * @return {string}
	 */
	function getHtml() {
		var html = '';

		// open modal button
		if (data.has_modal) {
			html += '<button class="grid-item__modal-trigger js-modal-open" type="button">';
		}

		// anchor
		if (data.has_article) {
			html += '<a href='+data.article_url+' target="blank">';
		}

		// image
		html += '<div class="grid-item__image border">' +
					'<div class="grid-item__image-ir ir">' +
						'<img class="lazyload desktop-and-tablet" data-srcset="'+_.getSizedImageUrl(data.grid_image, '261x')+' 1x, '+_.getSizedImageUrl(data.grid_image, '522x')+' 2x" alt="'+data.grid_image_alt+'" />' +
						'<img class="lazyload phone-only" data-srcset="'+_.getSizedImageUrl(data.grid_image, '356x')+' 1x, '+_.getSizedImageUrl(data.grid_image, 'master')+' 2x" alt="'+data.grid_image_alt+'" />' +
					'</div>' +
				'</div>';

		// title
		html += '<h3 class="grid-item__title">' +
					data.date +
				'</h3>';

        // close anchor tag for article link
		if (data.has_article) {
			html+= '</a>';
		}

		// product title
		if (data.product) {
			html += SDG.PressTemplate.productTitle(data, 'grid-item');
		}

		// close modal button
		if (data.has_modal) {
			html += '</button>';
		}

		return html;
	}

	return init();
};

/**
 * modal content
 * @param  {Object} data
 * @return {string}
 */
SDG.PressTemplate.modalContent = function(data) {

	function init() {
		return getHtml().trim();
	}

	function getHtml() {
		var html = '',
			productUrl = '/products/' + data.product.handle;


		// details image
		html += '<div class="press-modal__detail-image">' +
					'<div class="press-modal__detail-image-ir ir is-loading">' +
						'<img class="desktop-and-tablet lazyload" data-srcset="'+_.getSizedImageUrl(data.detail_image, '391x')+' 1x, '+data.detail_image+' 2x" alt="'+data.detail_image_alt+'" />' +
						'<img class="phone-only lazyload" data-srcset="'+_.getSizedImageUrl(data.detail_image, '370x')+' 1x, '+_.getSizedImageUrl(data.detail_image, '740x')+' 2x" alt="'+data.detail_image_alt+'" />' +
					'</div>' +
				'</div>';

		// open product
		html += '<div class="press-modal__product">';

		// product image
		html +=	'<a class="press-modal__product-image desktop-and-tablet" href="'+productUrl+'">' +
					'<div class="ir ir--product is-loading">' +
						'<img class="lazyload" data-srcset="'+_.getSizedImageUrl(data.product.featured_image, '245x')+' 1x, '+_.getSizedImageUrl(data.product.featured_image, '490x')+' 2x" alt="'+data.product.title+'" />' +
					'</div>' +
				'</a>';

		// product title
		html += '<a class="press-modal__product-title-link" href="'+productUrl+'">' +
					SDG.PressTemplate.productTitle(data, 'press-modal') +
				'<a>';

		// buy now button
		html += '<a class="press-modal__buy-btn btn phone-only" href="'+productUrl+'">' +
					'Buy Now' +
				'</a>';

		// close product
		html += '</div>';

		return html;
	}

	return init();
};

/**
 * modal content video
 * @param  {Object} data
 * @return {string}
 */
SDG.PressTemplate.modalContentVideo = function(data) {

	function init() {
		return getHtml().trim();
	}

	function getHtml() {
		return '<div id="vid" class="press-modal__video vid" data-video-id="'+data.video_id+'" data-video-player="'+data.video_type+'" data-video-title="'+data.video_image_alt+' video">' +
					'<div class="vid__image ir ir--vid is-loading js-vid-image">' +
						'<img class="lazyload" data-srcset="'+_.getSizedImageUrl(data.video_image, '654x')+' 1x, '+data.video_image+' 2x" alt="'+data.video_image_alt+'" />' +
					'</div>' +
				'</div>';
	}

	return init();
};

/**
 * product title
 * @param  {Object} data
 * @param  {string} mod  class module, ex. 'grid-item'
 * @return {string}
 */
SDG.PressTemplate.productTitle = function(data, mod) {

	function init() {
		return getHtml().trim();
	}

	function getHtml() {
		var html;

		html = '<h4 class="'+mod+'__product-title">' +
					getTitleTmHtml(data.product_title_tm) +
					data.product_title.trim() +
				'</h4>';

		return html;
	}

	/**
	 * get title tm html
	 * @param  {string} tm
	 * @return {string}
	 */
	function getTitleTmHtml(tm) {
		var html = '';

		if (tm) {
			html += '<span class="'+mod+'__product-title-tm">' +
						tm +
					'</span>';
		}

		return html;
	}

	return init();
};
/**
* press init
* @requires [lib/util.js]
*
* Press namespace
* init
*/

/**
* Press namespace
* @type {Object}
*/
SDG.Press = SDG.Press || {};

/**
 * init
 * @type {Function}
 */
SDG.Press.init = function() {
	var gridBaseOpts = {
			items: pressItems,
			item_template: SDG.PressTemplate.gridItem,
		},
		gridOpts = gridBaseOpts,
		modalContentTemplate = pressVideo ? SDG.PressTemplate.modalContentVideo : SDG.PressTemplate.modalContent,
		gridModalOpts,
		grid;

	// modal options
	if (pressModal) {

		gridModalOpts = {
			cls: {
				modal_details: 'press-modal__details'
			},
			id: {
				modal_content: 'pressModalContent',
				modal_details: 'pressModalDetails'
			},
			modal: true,
			modal_content_template: modalContentTemplate,
			modal_opts: {
				dom: {
					modal_id: 'pressModal',
					trigger: null
				}
			}
		};

		// extend options
		gridOpts = _.extend(gridBaseOpts, gridModalOpts);
	}

	// init grid
	grid = SDG.Grid.init(gridOpts);
	grid.init();
};

/**
* Press
* @requires [lib/press-templates.js, lib/util.js]
*
* namespace
* run
* run dom ready
* fire functions
*/

/**
* Press namespace
* @type {Object}
*/
SDG.Press = SDG.Press || {};

/**
 * run
 * @type {Function}
 */
SDG.Press.run = function() {

	// require grid, init press
	require([path.grid], SDG.Press.init);

	// mobile select drop down
	_.mq({
		view: 'phone',
		callback: SDG.MobileTab.init()
	});
};

/**
 * run
 * @type {Function}
 */
SDG.Press.runDomReady = function() {

	_.ready(function() {
	});
};

/**
 * fire functions
 */
SDG.Press.run();
SDG.Press.runDomReady();
